import { create } from 'zustand';

export const createConfigSlice = (set, get) => ({
  config: null,
  setConfig: (config) => set({ config }),
});
